// extracted by mini-css-extract-plugin
export default {"Phone":"VerifyPhone_Phone__NAjzm"};